export const SITE_NAME = 'Mach Exchange'
export const TITLE = 'Mach Exchange'
export const DESCRIPTION = 'Mach Protocol liquidity layer for Web3.0'
export const SITE_LOGO = 'https://app.mach.exchange/machFavicon.png'
export const SITE_URL = 'https://app.mach.exchange'
export const WALLET_CONNECT_PROJECT_ID = '3c8783f535be44f93360ee0638bd8bdd'
